import { Link } from "react-router-dom";
import { LOGO_SEAL } from "../lib/api";
import { Facebook, Youtube, Instagram, Mail, Phone, MapPin } from "lucide-react";

export default function Footer() {
  return (
    <footer className="bg-royal/60 border-t border-white/10" data-testid="site-footer">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand seal */}
          <div className="md:col-span-4 flex flex-col items-start">
            <img src={LOGO_SEAL} alt="SMZBT Logo" className="h-44 w-auto mb-6 opacity-95" />
            <p className="text-sm text-white/65 leading-relaxed max-w-xs font-light">
              Sixth Mount Zion Baptist Temple — Where Miracles Live. A Christ-centered family of faith in Hampton, Virginia, called to love God, love others, and serve the world.
            </p>
          </div>

          {/* Visit */}
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-ember mb-5 font-bold">Visit Us</div>
            <ul className="space-y-3 text-sm text-white/80">
              <li className="flex gap-3"><MapPin className="h-4 w-4 mt-0.5 text-ember/80 shrink-0" /><span>3100 Butternut Drive<br/>Hampton, VA 23666</span></li>
              <li className="flex gap-3"><Phone className="h-4 w-4 mt-0.5 text-ember/80 shrink-0" /><span>(757) 723-0249</span></li>
              <li className="flex gap-3"><Mail className="h-4 w-4 mt-0.5 text-ember/80 shrink-0" /><span>info@smzbt.org</span></li>
            </ul>
            <div className="mt-6 text-xs uppercase tracking-[0.3em] text-ember mb-3 font-bold">Office Hours</div>
            <ul className="space-y-1 text-sm text-white/80">
              <li>Tuesday – Friday · 10AM – 5PM</li>
            </ul>
            <div className="mt-6 text-xs uppercase tracking-[0.3em] text-ember mb-3 font-bold">Service Times</div>
            <ul className="space-y-1 text-sm text-white/80">
              <li>Sunday Worship · 7:00 AM & 10:00 AM</li>
              <li>Bible Study · Wed 7:00 PM</li>
            </ul>
          </div>

          {/* Quick links */}
          <div className="md:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-gold mb-5 font-semibold">Discover</div>
            <ul className="space-y-2 text-sm text-white/80">
              {[
                ["About", "/about"],
                ["Senior Pastor", "/pastor"],
                ["Ministries", "/ministries"],
                ["Church Calendar", "/calendar"],
                ["Book the Pastor", "/book-pastor"],
                ["Members Portal", "/members"],
                ["Ministry Media", "/ministry-media"],
              ].map(([label, to]) => (
                <li key={to}><Link to={to} className="hover:text-gold transition-colors">{label}</Link></li>
              ))}
            </ul>
          </div>

          {/* Give */}
          <div className="md:col-span-2">
            <div className="text-xs uppercase tracking-[0.3em] text-gold mb-5 font-semibold">Give</div>
            <p className="text-sm text-white/70 mb-4">Your generosity transforms lives.</p>
            <Link to="/donate" className="btn-wine inline-block px-5 py-2.5 rounded-full text-xs uppercase tracking-wider font-semibold" data-testid="footer-give-button">
              Give Now
            </Link>
            <div className="flex gap-3 mt-8">
              <a href="#" className="text-white/60 hover:text-gold transition-colors"><Facebook className="h-5 w-5" /></a>
              <a href="#" className="text-white/60 hover:text-gold transition-colors"><Youtube className="h-5 w-5" /></a>
              <a href="#" className="text-white/60 hover:text-gold transition-colors"><Instagram className="h-5 w-5" /></a>
            </div>
          </div>
        </div>

        <div className="divider-wine my-12" />

        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/45 uppercase tracking-widest">
          <div>© {new Date().getFullYear()} Sixth Mount Zion Baptist Temple. All rights reserved.</div>
          <a
            href="https://vzngfx.com"
            target="_blank"
            rel="noopener noreferrer"
            className="brand-gradient-text-warm font-bold normal-case tracking-wide hover:opacity-90 transition-opacity"
            data-testid="footer-vzngfx-credit"
          >
            Vision Brought to Life by VZNGFX →
          </a>
        </div>
      </div>
    </footer>
  );
}
